import React from 'react';
import { motion } from 'framer-motion';

interface DashboardSectionProps {
  title: string;
  children: React.ReactNode;
  delay?: number;
  className?: string;
  fullWidth?: boolean;
}

const DashboardSection: React.FC<DashboardSectionProps> = ({
  title,
  children,
  delay = 0,
  className = '',
  fullWidth = false
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden ${className} ${fullWidth ? 'lg:col-span-2' : ''
        }`}
    >

      <div className="p-4">
        {children}
      </div>
    </motion.div>
  );
};

export default DashboardSection;
